import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import VehicleCategoryServices from "services/VehicleCategoryServices";
import { notifyError, notifySuccess } from "utils/toast";

const useVehicleCategorySubmit = (id, carUrl, setCarUrl, primeCarUrl, setPrimeCarUrl) => {
  
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [existingImage, setExistingImage] = useState('');
  const [existingPrimeImage, setExistingPrimeImage] = useState('');
  const [isPrime, setIsPrime] = useState(false);
 const[loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    trigger,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      setIsSubmitting(true);
      if (!carUrl && !existingImage) {
        notifyError("Image is required.");
        setIsSubmitting(false);
        return;  
      }
      if(data.is_prime){
        if (!primeCarUrl && !existingPrimeImage) {
          notifyError("Prime Image is required.");
          setIsSubmitting(false);
          return;  
        }
      }
      
   if(carUrl){
    const partsLogo = carUrl.split("/");
      const filename_logo=partsLogo[partsLogo.length - 2]+'/'+partsLogo[partsLogo.length - 1];
      setCarUrl(filename_logo);
   }
   if(primeCarUrl){
    const partsLogo = primeCarUrl.split("/");
      const filename_logo=partsLogo[partsLogo.length - 2]+'/'+partsLogo[partsLogo.length - 1];
      setPrimeCarUrl(filename_logo);
   }
      const VehicleCategoryData = {

        name:data.name,
        seats: data.seats,
        similar_vehicle: data.similar_vehicle,
        no_of_bags: Number(data.no_of_bags),
        no_of_small_bags: Number(data.no_of_small_bags),
        vehicle_type : Number(data.vehicle_type),
        amenities: data.amenities || [], 
        image: carUrl || existingImage,
        prime: primeCarUrl || existingPrimeImage,
        benefits: data.benefits,
        is_prime: data.is_prime
      };
      if (id) {
        const res = await VehicleCategoryServices.updateVehicleCategory(id, VehicleCategoryData);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await VehicleCategoryServices.addVehicleCategory( VehicleCategoryData );
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
     // closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };

  const getVehicleCategoryData = async () => {
    try {
      const res = await VehicleCategoryServices.getVehicleCategoryById(id);
      if (res) {
        
      
        setValue("name",res.data.name);
        setValue("vehicle_type",res.data.vehicle_type);
        setValue("seats",res.data.seats);
        setValue("similar_vehicle",res.data.similar_vehicle);
        setValue("no_of_bags",res.data.no_of_bags);
        setValue("no_of_small_bags",res.data.no_of_small_bags);
        setValue("image",res.data.image);
        setValue("amenities", res.data.amenities || []);
        setValue("is_prime", res.data.is_prime);
        setIsPrime(res.data.is_prime);
        setValue("benefits",res.data.benefits);
        setExistingImage(res.data.image);
        setExistingPrimeImage(res.data.prime);
      }
    } catch (err) {
      closeDrawer();
      notifyError(err ? err?.response?.data?.message : err?.message);

    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setValue("name");
      setValue("vehicle_type");
      setValue("seats");
      setValue("no_of_bags");
      setValue("no_of_small_bags");
      setValue("image");
      setValue("amenities");
      setValue("similar_vehicle");
      setExistingImage("");
      setExistingPrimeImage("");
      setCarUrl("");
      setPrimeCarUrl("");
      setValue("prime");
      setValue("benefits");
      setIsPrime(false);
      clearErrors("name");
      clearErrors("seats");
      clearErrors("no_of_bags");
      clearErrors("vehicle_type");
      clearErrors("image");
      clearErrors("similar_vehicle");
      clearErrors();
      return;
    }
      
    if (id) {
      getVehicleCategoryData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue, isDrawerOpen, clearErrors]);


  return {
    register,
    handleSubmit,
    trigger,
    onSubmit,
    errors,
    isSubmitting,
    loading,setLoading,
    existingImage,
    existingPrimeImage,
    setExistingImage,
    setExistingPrimeImage,
    isPrime,
    setIsPrime
  };
};

export default useVehicleCategorySubmit;
